import filterIcon from "../../assets/filter.svg";
import { Button } from "src/shared/ui/Button";
import cn from "classnames";

import { useStyles } from "./styles";
import { useLocale } from "../../../../providers/LocaleProvider";

interface IFilterButton {
    onClick?: () => void;
}

export const FilterButton = ({ onClick }: IFilterButton) => {
    const classes = useStyles();
    const {
        lobby: {
            createGame: {
                buttons: { filter },
            },
        },
    } = useLocale();

    return (
        <Button
            text={filter("Filter")}
            variant="outlined"
            onClick={() => {
                onClick && onClick();
            }}
            color="shadow"
            border="borderNone"
            className={cn(classes.wrapper)}
            classNameIcon={cn(classes.filterIcon)}
            icon={filterIcon}
        />
    );
};
